<template>
  <div id="app">
  	<div class="logoCss"><img src="./assets/logo.png"></div>
    <!-- <router-view /> -->
    <hello-world></hello-world>
    <middle-set></middle-set>
    <bottom-set></bottom-set>
    <!-- <aa-b></aa-b> -->
  </div>
</template>

<script>
import HelloWorld from './components/HelloWorld'
import MiddleSet from './components/MiddleSet'
import BottomSet from './components/BottomSet'
// import AaB from './components/AaB'
export default {
  name: 'App',
  components: {
    MiddleSet,
    BottomSet,
    HelloWorld,
    // AaB
  },
  data () {
    return {
      Kilometer: 0,
      metre: 0,
      newVal: "",
      oldval: ''
    }
  },
  methods: {
    
  }
}
</script>

<style>
#app {
  background: url("./assets/bg.png");
  background-size: 100% 100%;
  background-repeat: "no-repeat";
  /* height: 100vh; */
  /* width: 100%; */
  /*height: 100%;*/
  padding: 40px 20px 17px;
  box-sizing: border-box;
  overflow: hidden;
}
.logoCss{
	position: absolute;
	top: 2%;
}
.logoCss > img{
	width: 74%;
}
body {
  margin: 0;
  /* overflow: hidden; */
}
div {
  color: #fff;
}
.class1 {
  background: #444;
  color: #eee;
}
</style>